import { isTokenExpired } from '../token-utils';
import type { AuthState } from './auth.provider';

export const getSessionCapabilities = (state: AuthState, offlineSessionEnabled: boolean) => {
  const isAuthenticated = state.status === 'authenticated';
  const canReplay = isAuthenticated && !isTokenExpired(state.token);

  return {
    canCaptureLocally: offlineSessionEnabled && isAuthenticated,
    canReplay,
  };
};
